export default __webpack_public_path__ + "static/media/snakee-game.1d23b84a.png";